import React from 'react';
import { Users, ShieldCheck, Leaf, ThumbsUp } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <Users className="w-8 h-8" data-id="element-198" />,
    text: '100.000+ zufriedene Kunden'
  }, {
    icon: <ThumbsUp className="w-8 h-8" data-id="element-199" />,
    text: 'Mit Tierärzten entwickelt'
  }, {
    icon: <Leaf className="w-8 h-8" data-id="element-200" />,
    text: '100% pflanzlich & natürlich'
  }, {
    icon: <ShieldCheck className="w-8 h-8" data-id="element-201" />,
    text: 'Geld-zurück-Garantie'
  }];
  return <section className="py-12 bg-forestGreen text-cream" data-id="element-202">
      <div className="max-w-6xl mx-auto px-4" data-id="element-203">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-204">
          {items.map((item, idx) => <div key={idx} className="flex flex-col items-center text-center gap-3" data-id="element-205">
              <div className="bg-cream/10 p-4 rounded-full" data-id="element-206">{item.icon}</div>
              <span className="font-serif font-medium text-sm md:text-base" data-id="element-207">
                {item.text}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}